import React, { useState, useEffect } from "react";
import EmployeeCard from "../components/Cards/EmployeeCard";
import "./MainPage.css";

import config from "../config.json";
import {
  MDBCard,
  MDBTabs,
  MDBTabsContent,
  MDBTabsItem,
  MDBTabsLink,
  MDBTabsPane,
} from "mdb-react-ui-kit";
import HeaderCard from "../components/Cards/HeaderCard";
import EmployeeTraining from "../components/Employee/EmployeeTraining";
import EmployeeComp from "../components/Employee/EmployeeComp";
import EmployeeDetails from "../components/Employee/EmployeeDetails";
import EmployeeEducation from "../components/Employee/EmployeeEducation";
import EmployeeCertificates from "../components/Employee/EmployeeCertificates";

function EmployeePage({ employeeQuery }) {
  const [justifyActive, setJustifyActive] = useState("portfolio");

  const [allEmpData, setAllEmpData] = useState("");
  const [employeeKSA, setEmployeeKSA] = useState("");
  const [showEmployeeData, setShowEmployeeData] = useState(false);

  const handleJustifyClick = (value) => {
    if (value === justifyActive) {
      return;
    }

    setJustifyActive(value);
  };

  useEffect(() => {
    (async () => {
      if (employeeQuery) {
        const response = await fetch(
          config.domainName + ":" + config.port + "/api/employeequery",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              function: "AllEmployeeData",
              employee_id: employeeQuery,
            }),
          }
        );

        const response2 = await fetch(
          config.domainName + ":" + config.port + "/api/employeequery",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              function: "EmployeeKSA",
              employee_id: employeeQuery,
            }),
          }
        );

        const content = await response.json();
        const content2 = await response2.json();
        console.log(content);
        console.log(content2);
        setAllEmpData(content);
        setEmployeeKSA(content2["user ksa"]);
        setShowEmployeeData(true);
      }
    })();
  }, []);

  return (
    <div className="bg-image">
      {allEmpData && (
        <div>
          <HeaderCard empName={allEmpData["employee"]["name"]} isEmp={true} />
          <div className="mainPageDiv" style={{ marginTop: "2%" }}>
            <MDBCard className="p-4 d-flex justify-content-center">
              <MDBTabs pills justify>
                <MDBTabsItem>
                  <MDBTabsLink
                    onClick={() => handleJustifyClick("portfolio")}
                    active={justifyActive === "portfolio"}
                    style={{
                      backgroundColor:
                        justifyActive === "portfolio" ? "#0550F0" : "",
                    }}
                  >
                    Portfolio
                  </MDBTabsLink>
                </MDBTabsItem>
                <MDBTabsItem>
                  <MDBTabsLink
                    onClick={() => handleJustifyClick("skills")}
                    active={justifyActive === "skills"}
                    style={{
                      backgroundColor:
                        justifyActive === "skills" ? "#0550F0" : "",
                    }}
                  >
                    All Skills
                  </MDBTabsLink>
                </MDBTabsItem>
                <MDBTabsItem>
                  <MDBTabsLink
                    onClick={() => handleJustifyClick("education")}
                    active={justifyActive === "education"}
                    style={{
                      backgroundColor:
                        justifyActive === "education" ? "#0550F0" : "",
                    }}
                  >
                    Education
                  </MDBTabsLink>
                </MDBTabsItem>
                <MDBTabsItem>
                  <MDBTabsLink
                    onClick={() => handleJustifyClick("certs")}
                    active={justifyActive === "certs"}
                    style={{
                      backgroundColor:
                        justifyActive === "certs" ? "#0550F0" : "",
                    }}
                  >
                    Certificates
                  </MDBTabsLink>
                </MDBTabsItem>
                <MDBTabsItem>
                  <MDBTabsLink
                    onClick={() => handleJustifyClick("training")}
                    active={justifyActive === "training"}
                    style={{
                      backgroundColor:
                        justifyActive === "training" ? "#0550F0" : "",
                    }}
                  >
                    Training Path
                  </MDBTabsLink>
                </MDBTabsItem>
                <MDBTabsItem>
                  <MDBTabsLink
                    onClick={() => handleJustifyClick("assessments")}
                    active={justifyActive === "assessments"}
                    style={{
                      backgroundColor:
                        justifyActive === "assessments" ? "#0550F0" : "",
                    }}
                  >
                    Assessments
                  </MDBTabsLink>
                </MDBTabsItem>
              </MDBTabs>
              <MDBTabsContent>
                <MDBTabsPane show={justifyActive === "portfolio"}>
                  {showEmployeeData && (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        width: "100%",
                      }}
                    >
                      <div style={{ width: "50%" }}></div>
                      <div
                        style={{
                          width: "50%",
                        }}
                      >
                        <EmployeeDetails employeeData={allEmpData} s />
                      </div>
                    </div>
                  )}
                </MDBTabsPane>
                <MDBTabsPane show={justifyActive === "skills"}>
                  <div className="m-4 d-flex justify-content-center">
                    <EmployeeComp ksaData={employeeKSA} />
                  </div>
                </MDBTabsPane>
                <MDBTabsPane show={justifyActive === "education"}>
                  <div className="m-4 d-flex justify-content-center align-content-center">
                    <EmployeeEducation employeeData={allEmpData} />
                  </div>
                </MDBTabsPane>
                <MDBTabsPane show={justifyActive === "certs"}>
                  <div className="m-4 d-flex justify-content-center">
                    <EmployeeCertificates employeeData={allEmpData} />
                  </div>
                </MDBTabsPane>
                <MDBTabsPane show={justifyActive === "training"}>
                  <div className="m-4">
                    <EmployeeTraining employeeData={allEmpData} />
                  </div>
                </MDBTabsPane>
                <MDBTabsPane show={justifyActive === "assessments"}>
                  <div className="m-4 d-flex justify-content-center">
                    <h2>Coming Soon</h2>
                  </div>
                </MDBTabsPane>
              </MDBTabsContent>
            </MDBCard>
          </div>
        </div>
      )}
    </div>
  );
}

export default EmployeePage;
